export const formatPhone = (dirtyNumber) => {
  if (!dirtyNumber) {
    return ''
  }
  
  // Remove all non-digit characters
  const cleaned = dirtyNumber.toString().replace(/\D+/g, '');
  
  // If it's 10 digits, format as (XXX) XXX-XXXX
  if (cleaned.length === 10) {
    return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  }
  
  // If it's 11 digits and starts with 1, remove the 1 and format
  if (cleaned.length === 11 && cleaned.startsWith('1')) {
    return cleaned.slice(1).replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  }
  
  // If it's 12+ digits and starts with +1, remove +1 and format
  if (cleaned.length >= 12) {
    return cleaned.slice(1).replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  }
  
  // Otherwise return as is
  return cleaned;
}

export const internationalPhoneFormat = (phone) => {
  return phone.replace(/\D+/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '+$1$2$3')
}

export const validateEmail = (email) => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  )
}

export function stringifyAddress(property, debug) {
  const { streetNumber, streetName, unit, city, state, zipCode, address } = property;
  
  // Build address from structured fields
  const parts = [];
  
  // Street address
  if (streetNumber && streetName) {
    parts.push(`${streetNumber} ${streetName}`);
  }
  
  // Unit
  if (unit) {
    parts.push(`Unit ${unit}`);
  }
  
  // City, State ZIP
  const cityStateZip = [city, state, zipCode].filter(Boolean).join(', ');
  if (cityStateZip) {
    parts.push(cityStateZip);
  }
  
  const builtAddress = parts.join(', ');
  
  // Fallback to old address field if new fields are not populated
  return builtAddress || address || '';
}

// let isPhone = (phone) => {
//   //normalize string and remove all unnecessary characters
//   phone = phone.replace(/\D+/g, '');
//   return phone.length == 10? true : false;
// }
